import createReducer from './createReducer';
import * as actions from '../actions/actionTypes';
import { mergeAll } from 'ramda';

const crossSellReducer = createReducer({}, {
  [actions.PERSONALIZED_QUOTE_RECEIVED]: (state, action) =>{
    return mergeAll([
      state,
      {
        crossSellPersonalizedQuote: action.crossSellPersonalizedQuote
      }
    ]);
  },
  [actions.ACCOUNT_INFO_UPDATE]: (state, action) => {
    return updateBankInfo(state, action);
  },
  [actions.ACCOUNT_TERM_INFO_UPDATE]: (state, action) => {
    return updateBankTermInfo(state, action);
  },
  [actions.ACCOUNT_SIGN_INFO_UPDATE]: (state, action) => {
    let newState={ ...state };
    newState.sign=action.sign;
    return newState;
  },
  [actions.CUSTOMER_INFORMATION]: (state, action) => {
    let newState={ ...state };
    newState.customerInformation=action.customerInformation;
    return newState;
  },
  [actions.UPDATE_OFFER_DETAILS]: (state, action) => {
    let newState={ ...state };
    newState.offerDetails=action.offerDetails;
    newState.crossSellPersonalizedQuote.apr=0;
    newState.crossSellPersonalizedQuote.costOfLoan=null;
    newState.crossSellPersonalizedQuote.financeCharge=null;
    newState.crossSellPersonalizedQuote.loanAmount=null;
    newState.crossSellPersonalizedQuote.monthlyPayment=0;
    newState.crossSellPersonalizedQuote.paymentDueDate=null;
    newState.crossSellPersonalizedQuote.termInMonths=null;
    return newState;
  },
  [actions.SPINNER_TOGGLE]: (state, action) => {
    let newState={ ...state };
    newState.spinnerToggle=!newState.spinnerToggle;
    return newState;
  },
  [actions.SHOW_COMMON_ALERT]: (state, action) => {
    let newState={ ...state };
    newState.showAlert={ ...action.showAlert };
    return newState;
  },
  [actions.ACCOUNT_TERM_CONDITION_UPDATE]: (state, action) => {
    return updateTermsConditionInfo(state, action);
  },
  [actions.COMPLETE_UPLOAD_DOCUMENT_STATUS]: (state, action) => {
    let newState={ ...state };
    newState.documentUploaded=action.documentUploaded;
    newState.status=action.status;
    return newState;
  },
  [actions.DECISION_API_RESPONSE]: (state, action) => {
    let newState={ ...state };
    newState.decisionApiResponse={ ...action.payload };
    return newState;
  },
  [actions.GENERATE_OTP_DATA]: (state, action) => {
    let newState={ ...state };
    newState.generateOtpResponse={ ...action.payload };
    return newState;
  },
  [actions.SET_BANK_ACCOUNT_INFO]: (state, action) => {
    let newState={ ...state };
    newState.bankInfo={ ...action.payload };
    return newState;
  },
  [actions.SET_VERID_QUESTIONS]: (state, action) => {
    let newState={ ...state };
    newState.veridQuestions={ ...action.payload };
    return newState;
  },
  [actions.SET_KBV_QUESTIONS]: (state, action) => {
    let newState={ ...state };
    newState.kbvQuestions={ ...action.payload };
    return newState;
  },
  [actions.SET_FOLLOWUP_QUESTIONS]: (state, action) => {
    let newState={ ...state };
    newState.decisionApiResponse.questions=action.payload;
    return newState;
  },
  [actions.SET_IDV_BTN_DISABLE]: (state, action) => {
    let newState={ ...state };
    newState.disableContinueBtnPerm = action.payload;
    return newState;
  },
  [actions.LOCKED_BROWSER_BACK]: (state, action) => {
    let newState={ ...state };
    newState.lockedBrowserBack=action.lockedBrowserBack;
    return newState;
  },

  [actions.UPDATE_BANK_ACCOUNT_LIST]: (state, action) => {
    let newState={ ...state };
    newState.externalAccountDetails=action.account;
    return newState;
  },
  [actions.LOCKED_BROWSER_BACK]: (state, action) => {
    let newState={ ...state };
    newState.lockedBrowserBack=action.lockedBrowserBack;
    return newState;
  },

  [actions.UPDATE_BANK_ACCOUNT_LIST]: (state, action) => {
    let newState={ ...state };
    newState.externalAccountDetails=action.account;
    return newState;
  }
});

const updateBankInfo=(state, action)=>{
  if(action.type === actions.ACCOUNT_INFO_UPDATE){
    let newState={ ...state };
    let info ={ ...newState.loanBankInfo };
    let accountsList =[...newState.externalAccountDetails];
    accountsList = accountsList.concat(action.loanBankInfo.accountList);
    newState.externalAccountDetails =[...accountsList];
    delete action.loanBankInfo['accountList'];
    info={ ...action.loanBankInfo };
    newState.loanBankInfo=info;
    return newState;
  }else{
    return state;
  }
};
const updateBankTermInfo=(state, action)=>{
  if(action.type === actions.ACCOUNT_TERM_INFO_UPDATE){
    let newState={ ...state };
    let offer ={ ...action.offerAcceptDetails };
    newState.offerAcceptDetails.electronicConsent =offer.electronicConsent;
    newState.offerAcceptDetails.legalTermsAndCondition =offer.legalTermsAndCondition;
    newState.offerAcceptDetails.privacyPolicy =offer.privacyPolicy;
    newState.offerAcceptDetails.isOfferAccepted =offer.isOfferAccepted;
    return newState;
  }else{
    return state;
  }
};

const updateTermsConditionInfo=(state, action)=>{
  if(action.type === actions.ACCOUNT_TERM_CONDITION_UPDATE){
    let newState={ ...state };
    let offer={ ...newState.offerAcceptDetails };
    offer.isOfferAccepted =action.isOfferAccepted;
    newState.offerAcceptDetails=offer;
    return newState;
  }else{
    return state;
  }
};

export default crossSellReducer;
